import { Row, Col } from "antd";
import React from "react";
import { BiRightArrow } from "react-icons/bi";
import { IoIosArrowRoundForward } from "react-icons/io";
import image1 from "../../../assets/frontendassets/Country/uk.png";
import image2 from "../../../assets/frontendassets/Country/aus.png";
import image3 from "../../../assets/frontendassets/Country/noida.png";
import image4 from "../../../assets/frontendassets/Country/canada.png";
import image5 from "../../../assets/frontendassets/Country/america.png";
const PopularLocation = () => {
  return (
    <>
     <div   className="flex items-center pt-[25px] xs:p-3 xxs:p-3 pb-10 lg:pl-14 lg:pr-14 md:pl-12 md:pt-12 md:pr-12 md:pb-2 lg:pb-2  xl:pl-14 xl:pt-14 xl:pr-12 xl:pb-1 sm:pl-6 sm:pt-6 sm:pr-6 sm:pb-8 bg-[#FFF8EC]"
     >
        <hr className="line xs:w-24 w-36 xxs:w-12  bg-[#FFF8EC]" />
        <div className="text-black ml-4 xxs:text-[16px] text-[20px] bg-[#FFF8EC] ">
         OUR GLOBAL PRESENCE
        </div>
      </div>

      <Row
        // gutter={{ xs: 0, sm: 0, md: 24, lg: 32 }}
        className="pt-0 xs:p-3 xxs:p-3 pb-10 lg:pl-12 lg:pr-12 md:pl-12 md:pt-12 md:pr-12 md:pb-4 lg:pb-2 justify-between xl:pl-12 xl:pt-12 xl:pr-12 xl:pb-1 sm:pl-6 sm:pt-6 sm:pr-6 sm:pb-8 bg-[#FFF8EC]"
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={16}
          xl={16}
          xxl={16}
          className="pb-[32px] lg:p-2"
        >
          <p
            className="text-xl sm:text-2xl font-semibold tracking-tight  mb-3"
            style={{ fontFamily: '"Manrope", sans-serif' }}
          >
            We are thrilled to announce that we are already present in major
            global markets, and we’re excited to continue helping you connect
            and grow your business worldwide.
          </p>

          <div className="relative bg-[#FFF8EC] rounded-md">
            <img
              src={image1}
              className="rounded-md h-[158px] xl:h-[190px] w-full"
              alt=""
            />
            <div className="absolute bottom-0 rounded-b-lg w-full p-2.5 bg-[#F9B138] text-left pl-4">
              <p className="text-black text-md md:text-xl flex items-center">
                Wokingham, United Kingdom{" "}
                <IoIosArrowRoundForward className="text-4xl text-black" />
              </p>
            </div>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={8}
          xl={8}
          xxl={8}
          style={{ height: "270px", marginBottom: "" }}
          className="lg:p-2"
        >
          {/* <div className="wrapper"> */}
          <div className="relative bg-[#FFF8EC]">
            <img src={image2} className="h-[270px] 2xl:h-[270px] xl:h-[270px] w-[100%]" alt="" />
            <div className="absolute bottom-0 rounded-b-lg w-full p-2.5 bg-[#F9B138] text-left pl-4">
              <p className="text-black text-md md:text-xl flex items-center">
                Sydney , Australia{" "}
                <IoIosArrowRoundForward className="text-4xl text-black" />
              </p>
            </div>
          </div>
          {/* </div> */}
        </Col>
      </Row>

      <Row
          // gutter={{ xs: 0, sm: 0, md: 24, lg: 32 }}
        className="md:pl-12  xxs:p-3 xs:p-3 md:pr-12 md:pb-12 justify-between xl:pl-12 xl:pt-0 xl:pr-12 xl:pb-12 sm:pl-6 sm:pr-6 sm:pb-8 bg-[#FFF8EC]"
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={8}
          xl={8}
          xxl={8}
          style={{ height: "300px", marginBottom: "" }}
          className="lg:p-2"
        >
          {/* <div className="wrapper"> */}
          <div className="relative bg-[#FFF8EC]">
            <img src={image3} className="rounded-md h-[270px] w-full" alt="" />
            <div className="absolute bottom-0 rounded-b-lg w-full p-2.5 bg-[#F9B138] text-left pl-4">
              <p className="text-black text-md md:text-xl flex items-center">
                Noida ,India{" "}
                <IoIosArrowRoundForward className="text-4xl text-black" />
              </p>
            </div>
          </div>
          {/* </div> */}
        </Col>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={8}
          xl={8}
          xxl={8}
          style={{ height: "300px", marginBottom: "" }}
          className="lg:p-2"
        >
          {/* <div className="wrapper"> */}
          <div className="relative bg-[#FFF8EC]">
            <img src={image4} className="rounded-md h-[270px] w-full" alt="" />
            <div className="absolute bottom-0 rounded-b-lg w-full p-2.5 bg-[#F9B138] text-left pl-4">
              <p className="text-black text-md md:text-xl flex items-center">
                Brampton , Canada{" "}
                <IoIosArrowRoundForward className="text-4xl text-black" />
              </p>
            </div>
          </div>
          {/* </div> */}
        </Col>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={8}
          xl={8}
          xxl={8}
          style={{ height: "300px", marginBottom: "" }}
          className="lg:p-2"
        >
          {/* <div className="wrapper"> */}
          <div className="relative bg-[#FFF8EC]">
            <img src={image5} className="rounded-md h-[270px] w-full" alt="" />
            <div className="absolute bottom-0 rounded-b-lg w-full p-2.5 bg-[#F9B138] text-left pl-4">
              <p className="text-black text-md md:text-xl flex items-center">
                Kentucky , United States{" "}
                <IoIosArrowRoundForward className="text-4xl text-black" />
              </p>
            </div>
          </div>
          {/* </div> */}
        </Col>
      </Row>
    </>
  );
};

export default PopularLocation;
